module.exports = __webpack_public_path__ + "static/media/headphones-alt.81a8e1ae.svg";